/* import __COLOCATED_TEMPLATE__ from './future-date-input-selector-row.hbs'; */
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
export default SelectKitRowComponent.extend({
  classNames: ["future-date-input-selector-row"]
});